// savedArticles — articles d'actualité enregistrés "à lire plus tard" (localStorage) (v5.11.0).
const KEY = "aya_saved_articles_v1";

export function listSavedArticles() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}

function _write(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* stockage plein */ }
  try { window.dispatchEvent(new Event("aya-saved-changed")); } catch { /* SSR */ }
}

export function isArticleSaved(id) {
  return listSavedArticles().some((s) => s.id === id);
}

/** Ajoute ou retire un article. Retourne true si ajouté, false si retiré. */
export function toggleSavedArticle(a) {
  const list = listSavedArticles();
  const i = list.findIndex((s) => s.id === a.id);
  if (i >= 0) { list.splice(i, 1); _write(list); return false; }
  list.unshift({
    id: a.id, title: a.title, url: a.url, source: a.source || null,
    age_label: a.age_label || null, tag: a.tag || null, flag: a.flag || null,
    image: a.image || a.thumbnail || null, saved_at: new Date().toISOString(),
  });
  _write(list.slice(0, 200));
  return true;
}

export function removeSavedArticle(id) {
  _write(listSavedArticles().filter((s) => s.id !== id));
}
